const dualList = {
  pickedAmount: '{{picked}} de {{total}} elementos seleccionados',
};

export default dualList;
